import { render, staticRenderFns } from "./ClientsFilter.vue?vue&type=template&id=20ce10d8&scoped=true"
import script from "./ClientsFilter.vue?vue&type=script&lang=js"
export * from "./ClientsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce10d8",
  null
  
)

export default component.exports